// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const categoryApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    // addCategory: builder.mutation({
    //   query: (data) => {
    //     return {
    //       url: "category",
    //       method: "POST",
    //       body: data,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    // updateCategory: builder.mutation({
    //   query: ({ data, id }) => {
    //     return {
    //       url: `category/${id}`,
    //       method: "PATCH",
    //       body: data,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    // deleteCategory: builder.mutation({
    //   query: (id) => {
    //     return {
    //       url: `category/${id}`,
    //       method: "DELETE",
    //       // body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    getAllCategory: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `category?${queryString}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetAllCategoryQuery,
} = categoryApi;
